export const getActiveLocaleCurrency = ({ activeLocale, intlConfig, }) => {
    return intlConfig.find((element) => element.code === activeLocale)?.currency;
};
